import styled from "styled-components";
export const LayoutContainer = styled.div`
  min-height: 65vh;
  padding: 32px 0;
  .side {
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
    overflow: hidden;
    padding: 16px;
    background-color:#fff;
    .info-box {
      margin-bottom: 16px;
      .title {
        display: block;
        font-weight: bold;
      }
      .value {
        display: block;
        color: #002a1a;
      }
    }
    button {
      width: 100%;
    }
  }
`;
